/**
 *  Do not use this to unsure that component exists. Compiler will still evaluate it
 * ```
 *  const obj: { a?: \{b?: number\}\} = \{ a: undefined \};
 *
 * // 🛑 This will throw an error
 * <Hide if={obj.a?.b}>{obj.a!.b}</Hide>
 *
 * // ✅ This will not throw an error
 * <Hide if={obj.a?.b}>{obj.a?.b}</Hide>
 * ```
 */
export const Hide: React.FC<{
  if?: unknown;
  children?: React.ReactNode;
}> = ({ if: _if, children }) => (_if ? null : <>{children}</>);
